// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"report-field_textContainer__2Vu3c","historyContainer":"report-field_historyContainer__1SNgq","subtitleNarrative":"report-field_subtitleNarrative__i8SEr"};